/**
 *
 * Util for emitting an event with the necessary peer information for the ice
 * collection scheduled check.
 * @method iceCollectionScheduledCheck
 * @param {Object} proxyBase The "base" of the Proxy Peer object.
 */
export default function iceCollectionScheduledCheck (proxyBase) {
  const { proxyPeer, iceTimer, iceCandidates, emitter, config } = proxyBase

  // The time, in milliseconds, that ICE collection has taken so far.
  const elapsedTime = iceTimer.timeFromStart()

  emitter.emit('scheduledCheck', {
    iceCollectionDuration: elapsedTime,
    iceCandidates,
    iceGatheringState: proxyPeer.iceGatheringState,
    rtcPeerConnectionConfig: config,
    rtcLocalSessionDescription: proxyPeer.localDescription
  })
}
